module.exports = __webpack_public_path__ + "static/media/source_learn_1.cb24ee0f.png";